import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.scss';

const COLOR_THEMES = [
  'teal',
  'kelp',
  'orange',
  'red',
  'berry',
  'mustard',
  'green',
  'aubergine',
  'anchovy',
  'black',
  'grey',
  'light-grey',
  'plus',
];

export { COLOR_THEMES };

export default function BottomSlant({ colorTheme }) {
  const classNames = classnames(styles['bottom-slant'], styles[`theme-${colorTheme}`]);

  return <div className={classNames} />;
}

BottomSlant.propTypes = {
  colorTheme: PropTypes.oneOf(COLOR_THEMES),
};

BottomSlant.defaultProps = {
  colorTheme: 'teal',
};
